import { FieldDefinition, ICalculatedFormField } from 'types/form-types';

const isCalculatedField = <DataModel>(
  fieldDefinition: FieldDefinition<DataModel>
): fieldDefinition is ICalculatedFormField<DataModel> => {
  return fieldDefinition.hasOwnProperty('calculate');
};

export { isCalculatedField };
